<template>
  <div v-loading="loading">
    <div class="header">
      <el-select v-model="info_type" @change="getStateBudget">
        <el-option v-for="{type, title} in infoTypes" :key="type" :value="type"
                   :label="title"/>
      </el-select>
      <el-button type="primary" @click="$router.push({name: 'SateBudgetAdd'})">Davlat budjeti turi qo'shish</el-button>
    </div>
    <el-table :data="tableData" border height="calc(100vh - 250px)">
      <el-table-column type="index" label="T/r" />
      <el-table-column prop="budget_year" label="Budjet yili"/>
      <el-table-column prop="added_at" label="Qo'shilgan sanasi">
        <template #default="scope">
          {{$moment(scope.row.added_at).format("DD.MM.YYYY")}}
        </template>
      </el-table-column>
      <el-table-column align="center" width="420">
        <template #default="scope">
          <el-button size="small" type="primary" @click="$router.push({name: 'StateBudgetRows', params:{stateBudgetId: scope.row.id}})">Davlat budjeti ma'lumotlari</el-button>
          <el-button size="small" type="success" :loading="downloadingId === scope.row.id" @click="downloadExcel(scope.row)">
            <img src="@/assets/images/icons/download.svg" alt="" style="margin-right: 5px" />
            Excelga yuklab olish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";
import {blobErrorMessage} from "@/utils/common";

// Admin panel'ning yagona ishlaydigan interfeys tili — hozircha til
// almashtirgich yo'q (StateBudgetRows.vue'dagi HL_HEADER konvensiyasiga mos).
const HL_HEADER = {hl: "uz_lat"};

export default {
  name: "StateBudgetList",
  data() {
    return {
      loading: false,
      downloadingId: null,
      tableData: [],
      info_type: 'INCOME',
      infoTypes: [{type:'INCOME', title: 'Daromadlar'},{type:'OUTCOME', title: 'Xarajatlar'}]
    }
  },
  methods: {

    getFileName(headers, fallback) {
      const contentDisposition = headers?.["content-disposition"] || headers?.["Content-Disposition"];
      if (!contentDisposition) return fallback;
      const fileNamePart = contentDisposition.split(";").find((item) => item.trim().startsWith("filename="));
      if (!fileNamePart) return fallback;
      return decodeURIComponent(fileNamePart.split("=")[1].trim().replace(/^"(.*)"$/, "$1"));
    },

    downloadExcel(row) {
      this.downloadingId = row.id
      this.$http.get("api/v1/state-budget/excel", {
        params: {year: row.budget_year, info_type: this.info_type},
        responseType: "blob",
        headers: HL_HEADER,
      }).then((res) => {
        const url = URL.createObjectURL(new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        }))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", this.getFileName(res.headers, `State-Budget-${this.info_type}-${row.budget_year}.xlsx`))
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }).catch(async ({response}) => {
        ElNotification({
          type: 'warning',
          title: 'Ogohlantirish',
          message: await blobErrorMessage(response, "Faylni yuklab olishda xatolik yuz berdi!")
        })
      }).finally(() => {
        this.downloadingId = null
      })
    },

    getStateBudget() {
      this.loading = true
      this.$http.get(`api/v1/state-budget?info_type=${this.info_type}`).then(({data}) => {
        this.tableData = data
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },

  },
  mounted() {
    this.getStateBudget();
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
</style>